import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from '../lib/Link'
import LazyImage from '../lib/LazyImage'
import {Text} from '../field'

class BlockSlide extends Component {
	render() {
		const {entity, block, classes, menu, screen} = this.props
		
  		let slideIndex = -1
  		if(block.img && block.img.length>0) {
  			slideIndex = 0
  		
  			if(block.img.length===2) {
  				slideIndex = (screen.o==='l'?0:1)
			}
			if(block.img.length===4) {
  				switch(screen.r) {
  					case '16x9':
  						slideIndex = (screen.o==='l'?0:1)
	  					break
  					default:
  						slideIndex = (screen.o==='l'?2:3)
  						break
  				}
			}
  		}
		
		return (
	<div className={classes} id={`block-${block.uuid}`}>
		{slideIndex>=0 && <LazyImage className='slide-bg' src={block.img[slideIndex]} bg={true} screen={screen}/> }
		{menu}
  		
	    <div className={'slide__text o-'+screen.o}><div className='text-in'>
	    	<Text entity={entity} block={block} fieldName='h3' tag='h3' value={block.h3}/>
    		<Text entity={entity} block={block} fieldName='h1' tag='h1' value={block.h1}/>
    		<Text entity={entity} block={block} fieldName='h2' tag='h2' value={block.h2}/>
    		<Text entity={entity} block={block} fieldName='text' value={block.text}/>
    		{block.link && <Link className='button large' to={block.link}>{block.call}</Link>}
    	</div></div>
    </div>
		)
	}
}
function mapStateToProps(state, ownProps) {
	return {
		o: state.screen.o,
		ratiobk: state.screen.ratiobk,
	}
}

export default connect(mapStateToProps)(BlockSlide);



// WEBPACK FOOTER //
// ./src/fm/block/BlockSlide.js